import { FloatingCallback } from "@acko-tech/building-blocks.ui.header-help-modal";
import Help from "@acko-tech/building-blocks.ui.header-help-modal";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { useOnload } from "@utils/useOnLoad";
import { connect } from "react-redux";
import { Wrapper } from "./styles";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { getRequestpayload } from "@utils/index";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const TalkToUs = (props) => {
  const {
    styles,
    is_visible,
    registeredMobileNumber,
    proposalMobileNumber,
    actions
  } = props || {};

  if (!is_visible) {
    return null;
  }

  const { on_load, on_click } = actions || {};

  useOnload({ on_load });
  const { data, journey } = getRequestpayload();

  const handleOnClick = () => {
    if (on_click?.[0] && typeof on_click[0].funCall === "function") {
      on_click[0].funCall(on_click[0].args || {});
    }
    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "tap_btn_talk_to_us",
        action_type: "tap_btn",
      },
      odata: {
        journey
      },
      event_name: "action"
    })
  };

  const handleSubmitClick = () => {
    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "tap_btn_call_scheduled",
        action_type: "tap_btn",
      },
      odata: {
        journey
      },
      event_name: "action"
    })
  }
  return (
    <Wrapper styles={styles}>
      <Help
        isDesktop={true}
        floatingCallback={FloatingCallback.TALK_TO_US_CALLBACK_CTA}
        color="#7C47E1"
        backgroundColor="white"
        hideBorder={true}
        buttonStyles={{
          colorScheme: {
            disabled: "#E5E5E5",
            lightest: "#0FA457",
            light: "#0FA457",
            normal: "#0FA457",
            dark: "#149452"
          }
        }}
        proposalMobileNumber={proposalMobileNumber}
        registeredMobileNumber={registeredMobileNumber}
        helpButtonClick={handleOnClick}
        onSubmitClick={handleSubmitClick}
      />
    </Wrapper >
  );
};

export default connect(mapStateToProps)(TalkToUs);
